import React, { useEffect, useState } from "react";

import "./contactSupport.scss";
import parse from "html-react-parser";
import { close } from "../../assets/images/icons";
import {
  ingestData,
  isMobile,
  navigateToURL,
} from "../../bridges/BridgeServices";
import Chatbot from "../Chatbot/Chatbot";
import PropTypes from "prop-types";
import ChatBotMeta from "../../utils/singletonChatBotMeta";
import { openBot } from "../Chatbot/ChatbotUtil";
import {
  EVENTS,
  CHATBOT_CONTEXT,
} from "../../utils/constants";
import { getValueForQueryParam } from "../../utils/helperFunctions";

const ContactSupport = ({ faqTitle = "" }) => {
  const [shouldOpenChatbot, setOpenChatbot] = useState(
    false
  );

  // Adding FAQ as src in chatbot meta as it is needed to open relevant chatbot
  useEffect(() => {
    const data = {
      ...(faqTitle && {
        faqTitle,
      }),
      src: "FAQ",
    };
    ChatBotMeta.update(data);
    return () => {
      const data = {
        faqTitle: "",
        src: getValueForQueryParam("src"),
      };
      ChatBotMeta.update(data);
    };
  }, []);

  return (
    <>
      <div
        className="support-close-icon hide"
        onClick={() => {
          setOpenChatbot(false);
          document
            .getElementById("mobile-chat-container")
            ?.click();

          if (
            document?.getElementsByClassName(
              "support-close-icon"
            )?.[0]
          ) {
            document.getElementsByClassName(
              "support-close-icon"
            )[0].style.display = "none";
            document
              .getElementsByClassName(
                "support-close-icon"
              )[0]
              .classList.add("hide");
          }
        }}
      >
        {parse(close)}
      </div>
      <div className="contact-support-wrapper">
        <p className="contact-support-text">
          Need more help?
        </p>
        <div
          className="contact-support"
          onClick={() => {
            ingestData({
              name: EVENTS.CHATBOT_CLICKED,
              data: {
                context: CHATBOT_CONTEXT.LOCAL,
                faqTitle,
              },
            });
            if (isMobile()) {
              navigateToURL("CHATBOT");
            } else {
              if (
                shouldOpenChatbot ||
                document.getElementsByClassName(
                  "loading-bot"
                )?.[0]
              ) {
                return;
              }
              setOpenChatbot(true);
              openBot();
            }
          }}
        >
          <div
            className={`contact-support-content ${
              !isMobile() ? "loading-bot" : ""
            }`}
          >
            CONTACT SUPPORT
          </div>
        </div>
        <Chatbot
          shouldOpenChatbot={shouldOpenChatbot}
          chatBotContext={CHATBOT_CONTEXT.LOCAL}
        />
      </div>
    </>
  );
};

export default ContactSupport;

ContactSupport.propTypes = {
  faqTitle: PropTypes.string,
};
